<section class="container">
  <div class="bn-form-group row">
    <div class="col">
      <h3>Histórico</h3>
    </div>
    <div class="col-auto">
      <button type="button" class="btn btn-primary" routerLink="..">
        Voltar
      </button>
    </div>
  </div>
  <div class="row">
    <div class="bn-form-group col-8">
      <label class="form-label">Pagamento ECG feito Por: </label>
      <select
        class="form-control"
        [formControl]="tipoPagamentoEcgTerceiroControl"
      >
        <option [value]="null"></option>
        <option *ngFor="let tipo of tipos" [value]="tipo.ide">
          {{ tipo.nomeTipoPagamentoEcgTerceiro }}
        </option>
      </select>
    </div>
  </div>
  <div class="row">
    <bn-paginacao
      [total]="atributosPaginacao.count"
      [tamanhoPagina]="atributosPaginacao.pageSize"
      [numPagina]="atributosPaginacao.page"
      [opcoesTamanhoPagina]="opcoesPaginacao"
      (aoMudar)="mudancaPagina($event)"
      class="bn-paginacao-container"
    >
      <div class="table-responsive">
        <table class="table table-hover">
          <thead>
            <tr>
              <th id="col-dataCriacao" scope="col">
                <bn-ordenacao
                  [ordenacao]="atributosOrdenacao"
                  [atributo]="'dataCriacao'"
                  [nomeAtributoExibicao]="'Dt. criação'"
                  (aoClickar)="mudancaOrdenacao($event)"
                >
                </bn-ordenacao>
              </th>
              <th id="col-usuarioResponsavel" scope="col">
                <bn-ordenacao
                  [ordenacao]="atributosOrdenacao"
                  [atributo]="'usuarioResponsavel'"
                  [nomeAtributoExibicao]="'Usuário responsável'"
                  (aoClickar)="mudancaOrdenacao($event)"
                >
                </bn-ordenacao>
              </th>
              <th id="col-dataReferencia" scope="col">
                <bn-ordenacao
                  [ordenacao]="atributosOrdenacao"
                  [atributo]="'dataReferencia'"
                  [nomeAtributoExibicao]="'Dt. referência'"
                  (aoClickar)="mudancaOrdenacao($event)"
                >
                </bn-ordenacao>
              </th>
              <th id="col-valorTotalLimiteContratacao" scope="col">
                <bn-ordenacao
                  [ordenacao]="atributosOrdenacao"
                  [atributo]="'valorTotalLimiteContratacao'"
                  [nomeAtributoExibicao]="' Valor total limite contr.'"
                  (aoClickar)="mudancaOrdenacao($event)"
                >
                </bn-ordenacao>
              </th>
              <th id="col-comentarios" scope="col">
                <bn-ordenacao
                  [ordenacao]="atributosOrdenacao"
                  [atributo]="'comentarios'"
                  [nomeAtributoExibicao]="'Comentários'"
                  (aoClickar)="mudancaOrdenacao($event)"
                >
                </bn-ordenacao>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let historico of historicos">
              <td>
                {{ historico.dataCriacao | date : "dd/MM/yyyy HH:mm:ss" }}
              </td>
              <td>{{ historico.usuarioResponsavel }}</td>
              <td>{{ historico.dataReferencia | date : "dd/MM/yyyy " }}</td>
              <td>{{ historico.valorTotalLimiteContratacao }}</td>

              <td>{{ historico.comentarios }}</td>
            </tr>
            <tr *ngIf="historicos.length === 0">
              <td colspan="5" class="texto-sem-registro">Sem registros</td>
            </tr>
          </tbody>
        </table>
      </div>
    </bn-paginacao>
  </div>
</section>
